import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/exame-imagem`

    const headers = { responseType: "arraybuffer" }

    return {
        lancamento(idPaciente) {
            return repository.get(`${baseUrl}/relatorio-lancamento/${idPaciente}`, headers)
        },
        relatorioExameStatus(params) {
            return repository.post(`${baseUrl}/relatorio-exame-status`, params, headers)
        },
        listagem(queryParms) {
            return repository.get(`${baseUrl}/listagem?${urlUtil.serialize(queryParms)}`, headers)
        },
        historicoExame(idPaciente) {
            return repository.get(`${baseUrl}/historico-exame/${idPaciente}`, headers)
        },
        relatorioProducao(queryParms) {
            return repository.get(`${baseUrl}/relatorio-producao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioCotaProfissional(queryParms) {
            return repository.get(`${baseUrl}/relatorio-cota-profissional?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}